// extracted by mini-css-extract-plugin
export var brand = "_88-9";
export var compact = "_88-6";
export var extraSmall = "_88-7";
export var icon = "_88-0";
export var large = "_88-4";
export var light = "_88-1";
export var medium = "_88-5";
export var outline = "_88-b";
export var primaryDark = "_88-a";
export var primaryLight = "_88-8";
export var primaryModern = "_88-c";
export var success = "_88-2";
export var successSolid = "_88-3";